import { closingDeals } from "../consts";

export const tokenHeader = 'x-access-token';
export const getUserToken = () => {
    return localStorage.getItem('userToken');
}

const apiEndPoint = closingDeals;

export const getAllCloseDeal = async() => {
    try {
        return await fetch(apiEndPoint + '/all', {
            headers: {
                [tokenHeader]: getUserToken()
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                let responce = result.filter(item => item.status == "Leads")
                // console.log("result:>",typeof(result));
                // console.log("result:>",result);
                return responce;
            },
            (error) => {
                return error;
            }
        )   
    } catch (err) {
        console.log(":: getAllCloseDeal ::>",err)
    }
}